import {atomWithReset} from "jotai/utils";

export const timezoneAtom = atomWithReset("Europe/Warsaw")
